import _ from 'underscore';
import { useContext, useState, useEffect } from 'react';
import { isAdBlockOn } from '@bingads-webui-campaign/block-ad-block';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

const WARNING_MESSAGE = _TL_('It looks like you have an ad-blocking extension enabled. Please disable this extension as it may interfere with some of our tools.');
const DEFAULT_QUERY = 'help:56790';

export function useAdBlockerDetection({
  i18n,
  query = DEFAULT_QUERY,
  logMessage = _.noop,
}) {
  const [adBlockOn, setAdBlockOn] = useState(false);
  const serverContext = useContext(ServerContext);

  useEffect(() => {
    let cancelled = false;
    const { CampaignUIAPI } = serverContext.ServicesEndpoints;
    isAdBlockOn({
      CampaignUIAPI,
      logMessage,
    }).then((result) => {
      if (!cancelled) {
        setAdBlockOn(result);
      }
    });
    return () => { cancelled = true; };
  }, [logMessage, serverContext]);

  if (adBlockOn) {
    return [{
      message: i18n.getString(WARNING_MESSAGE),
      actionList: [{
        text: i18n.getString(_TL_('Learn more')),
        extraAttrs: {
          role: 'button',
          className: 'HelpTopic adBlockerLearnMore clickable',
          query,
          href: '#!',
        },
      }],
    }];
  }
  return [];
}
